import PropTypes from 'prop-types';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthGuard, RoleBasedGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import { LoadingScreen } from 'src/components/loading-screen';

const PageView = ({ permission }) => (
  <AuthGuard>
    <DashboardLayout>
      <RoleBasedGuard permission={permission}>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </RoleBasedGuard>
    </DashboardLayout>
  </AuthGuard>
);

export default PageView;

PageView.propTypes = {
  permission: PropTypes.string,
};
